import { Button } from "@/components/ui";
import { createLink } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import * as React from "react";

const BackButtonBase = React.forwardRef<
  HTMLButtonElement,
  Omit<React.ComponentProps<typeof Button>, "onClick"> & {
    children?: React.ReactNode;
  }
>(({ children, className, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      variant="outline"
      size={children ? "sm" : "icon"}
      className={className}
      {...props}
    >
      <ArrowLeftIcon className="size-4" />
      {children ? <span className="ml-1">{children}</span> : <span className="sr-only">Back</span>}
    </Button>
  );
});
BackButtonBase.displayName = "BackButtonBase";

export const BackButton = createLink(BackButtonBase);
